export const HOME = 'home';
export const ONBOARDING = 'onboarding';
export const VERIFICATION = 'verification';
export const DASHBOARD = 'dashboard';
export const COMMON = 'common';
export const SETTINGS = 'settings';

export const AVAILABLE_LANGUAGES = {
  en: 'en',
  ar: 'ar'
};

export const DEFAULT_LNG = AVAILABLE_LANGUAGES.en;
export const LANGUAGES = [AVAILABLE_LANGUAGES.en /*AVAILABLE_LANGUAGES.ar*/];
export const DEFAULT_NS = 'common';
export const COOKIE_NAME = 'portalLang';

export const ACKNOWLEDGE_THROUGH = {
  SIGNATURE: 'signature'
};
export const TRACK_CASE = 'trackCase';
